/**
 * Временное решение для удаление дубликатов
 * Проблема наблюдается именно при авторизации на странице рейтинга. Двойной запрос.
 * В других случаях такого нет.
 * https://redmine.mamba.ru/issues/114378
 */
import { definitions } from 'api/generated/ratings_v2.voting'

export const deleteDuplicatePhotos = (
  currentPhotos: definitions['RatingVotingPhoto'][],
  incomingPhotos: definitions['RatingVotingPhoto'][]
) => {
  if (currentPhotos.length === 0) {
    return [...incomingPhotos]
  } else {
    const mergeArray = [...currentPhotos, ...incomingPhotos]
    const photos = mergeArray.reduce<definitions['RatingVotingPhoto'][]>(
      (acc, photo) => {
        const hasAlreadyCurrentPhoto = acc.find(
          (accPhoto) => accPhoto.photoId === photo.photoId
        )

        if (hasAlreadyCurrentPhoto) {
          return [
            ...acc.map((accPhoto) =>
              // Возмем фото из incomingPhotos, чтобы были свежие данные
              accPhoto.photoId === photo.photoId ? photo : accPhoto
            ),
          ]
        }

        return [...acc, photo]
      },
      []
    )

    return [...photos]
  }
}
